module.exports = __webpack_public_path__ + "assets/icon-1-38d5ad4c.png";